import Skeleton from "@material-ui/lab/Skeleton";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Snackbar, Stack } from "@mui/material";
import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { ASSETS } from "../../utils/config";
import EditProfileCard from "./EditProfileCard";
import { TextView } from "..";
import { colors } from "../../utils";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const socialPlatforms = {
  youtube: ASSETS.youtubeIcon,
  facebook: ASSETS.profileFacebook,
  linkedin: ASSETS.bb_social_linkedin,
  twitter: ASSETS.bb_social_twitter,
  instagram: ASSETS.bb_social_instagram,
  tiktok: ASSETS.bb_social_tiktok,
};

export default function ProfileDetailsCard({
  profileImg = "",
  name,
  desc,
  editicon,
  following,
  followers,
  isLoading,
  profileData,
  isEditable = false,
  websiteUrl,
}) {
  const [open, setOpen] = useState(false);
  const [editable, setEditable] = useState(false);
  const [showCopy, setShowCopy] = useState(false);
  const social_media_links = profileData?.social_media_links ?? {};

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleShare = () => {
    setOpen(true);
    navigator.clipboard.writeText(
      window.location.origin + "/otheruserprofile/" + profileData?.user_id
    );
  };

  return (
    <>
      <Card
        style={{
          borderRadius: "20px",
          border: 0,
          width: "100%",
        }}
      >
        {isLoading ? (
          <Skeleton
            variant="rect"
            height={150}
            width={"100%"}
            style={{ borderRadius: "20px" }}
          />
        ) : (
          <Card.Body>
            {editable ? (
              <EditProfileCard
                userProfile={profileData}
                onBackClick={() => setEditable(false)}
              />
            ) : (
              <>
                <div className="row">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      marginBottom: 10,
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <img
                        alt="dp"
                        src={profileImg ? profileImg : ASSETS.userPlaceholder}
                        style={{
                          height: "50px",
                          width: "50px",
                          borderRadius: "50px",
                        }}
                      />
                      <Stack style={{ width: "10vw" }} marginLeft={1}>
                        <TextView className="mb-2" variant="title">
                          {name}
                        </TextView>
                        <Card.Subtitle className="mb-2">
                          <TextView
                            style={{ color: colors.darkGrey }}
                            variant="subtitle"
                          >
                            {profileData?.profession}
                          </TextView>
                        </Card.Subtitle>
                      </Stack>
                    </div>

                    <Stack
                      display={"flex"}
                      flexDirection={"row"}
                      justifyContent={"flex-end"}
                    >
                      {isEditable && (
                        <div style={{ display: "flex" }}>
                          <img
                            src={editicon}
                            onClick={() => setEditable(true)}
                            alt={"Favourite"}
                            style={{
                              height: "15px",
                              width: "15px",
                              cursor: "pointer",
                              marginRight: 5,
                            }}
                          />
                        </div>
                      )}
                      <div style={{ display: "flex" }}>
                        <img
                          src={ASSETS.share}
                          onClick={handleShare}
                          alt={"share"}
                          style={{
                            height: "15px",
                            width: "15px",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </Stack>
                  </div>
                </div>

                <Stack gap={2} direction={"row"}>
                  <TextView variant="text">{following} following</TextView>
                  <div
                    style={{
                      height: 20,
                      width: 1.5,
                      backgroundColor: colors.lightGrey,
                    }}
                  ></div>
                  <TextView variant="text">{followers} followers</TextView>
                </Stack>

                <TextView
                  style={{
                    whiteSpace: "pre-wrap",
                    overflowWrap: "break-word",
                    paddingBottom: "14px",
                    marginTop: 10,
                  }}
                >
                  {desc}
                </TextView>
                {!!social_media_links["website"] && (
                  <Stack
                    onMouseOut={() => setShowCopy(false)}
                    onMouseOver={() => setShowCopy(true)}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      padding: 7,
                      alignItems: "center",
                      borderRadius: 20,
                      marginBottom: 10,
                      height: 28,
                    }}
                  >
                    <img
                      alt="weblogo"
                      src={ASSETS.website}
                      style={{
                        width: 18,
                        height: 18,
                        marginRight: 10,
                        marginLeft: "-7px",
                      }}
                    />
                    <a
                      href={social_media_links["website"]}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <TextView
                        variant="text"
                        color={colors.darkBlue}
                        style={{
                          fontWeight: "bold",
                          textDecoration: "underline",
                        }}
                      >
                        {social_media_links["website"].slice(0, 20)}
                      </TextView>
                    </a>

                    {showCopy && (
                      <Stack
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        sx={{
                          background: "#F6F7F9",
                          padding: 0.3,
                          borderRadius: 10,
                          pl: 1,
                          pr: 1,
                          ml: 2,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setOpen(true);
                          navigator.clipboard.writeText(
                            social_media_links["website"]
                          );
                        }}
                      >
                        <ContentCopyIcon
                          style={{ fontSize: "12px", marginRight: "3px" }}
                        />
                        <TextView
                          style={{
                            fontSize: "9px",
                          }}
                          variant="tag"
                        >
                          Copy
                        </TextView>
                      </Stack>
                    )}
                  </Stack>
                )}
                <Stack direction={"row"} gap={2}>
                  {Object.keys(social_media_links).map((link) => {
                    if (link && link !== "website")
                      return (
                        <a
                          href={social_media_links[link]}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            style={{ borderRadius: 5 }}
                            width={20}
                            height={20}
                            src={socialPlatforms[link]}
                            alt={link}
                          />
                        </a>
                      );
                  })}
                </Stack>
              </>
            )}
          </Card.Body>
        )}
      </Card>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={open}
        autoHideDuration={2000}
        onClose={handleClose}
        message={`Link copied to clipboard!`}
        action={
          <>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
      />
    </>
  );
}
